'use strict';

angular.module('shiftTraderApp')
    .directive('saNoteRelationView', ['Session', 'Users', 'PositionsStore', 'WorkPeriods', '$compile', '$q', 'TimeService', function(Session, Users, PositionsStore, WorkPeriods, $compile, $q, TimeService) {
      return {
        template: '<div class="sa-note-relation-view"></div>',
        restrict: 'A',
        scope: {
          relations: '='
        },
        require: '?^saNoteCreate',
        controllerAs: 'RelationView',
        link: function(scope, elem, attrs, parentCtrl) {
          scope.data = {};

          // Templates
          var templates = {
            User: '<div sa-profile-picture="::data.user" size="super_tiny"></div><a user-link="::data.user" link="true">{{::data.user.first_name}} {{::data.user.last_name}}</a>',
            Position: '<span class="sa-note-relation-symbol"></span><span class="sa-note-relation-label"><a href="{{::data.position.url}}">{{::data.position.name}}</a></span>',
            WorkPeriod: '<span class="sa-note-relation-symbol"><i class="icon-building"></i></span><span class="sa-note-relation-label">{{::data.wp.position.name}} Shift: {{::data.wp.start_time.format(\'MM/DD\')}} from {{::data.wp.start_time.format(\'h:mma\') | stripCharacters:1}} to {{::data.wp.end_time.format(\'h:mma\') | stripCharacters:1}}</span>',
            Dates: '<span class="sa-note-relation-symbol"><i class="sa-icon-cal-blackout-1"></i></span><span class="sa-note-relation-label" ng-bind-html="data.dates.html"></span>',
            OpenEndedDate: '<span class="sa-note-relation-symbol"><i class="sa-icon-cal-blackout-1"></i></span><span class="sa-note-relation-label">From <span class="the-date">{{::data.dates.startFormatted}}</span> on</span>',
            Reply: '<span class="sa-note-relation-symbol"><i class="icon-mail-reply"></i></span><span class="sa-note-relation-label">Attached as a reply</span>'
          };

          var setContent = function(html) {
            $(elem).find('.sa-note-relation-view').html(html);
          };

          // First, it it's a reply, we're already done.
          if (parentCtrl && parentCtrl.note && !!parentCtrl.note.parent_id) {
            setContent('<div>' + templates['Reply'] + '</div>');
            return;
          }

          // Otherwise, we'll need some extra stuff
          var fetchers = {
            User: Users.getById,
            Position: PositionsStore.getRecordById,
            WorkPeriod: WorkPeriods.getById
          };

          var configurators = {
            Position: function(position) {
              position.url = '#/organizationProfile/' + position.organization_id + '/positions/' + position.id;
              scope.data.position = position;
              return scope.data.position;
            },
            Dates: function(relation) {
              scope.data.dates = {};

              if (relation.start_date.isSame(relation.end_date, 'minutes')) {
                scope.data.dates.html = relation.start_date.format('dd, MMM D, YYYY h:mma').slice(0, -1);
              } else {
                var min = TimeService.minimalIntervalTimeFormat(moment(relation.start_date).twix(moment(relation.end_date)), undefined, 'ddd, MMM D');
                scope.data.dates.html = min.strings.htmlInterval;
              }

            },
            OpenEndedDate: function(relation) {
              scope.data.dates = {};
              scope.data.dates.startFormatted = relation.start_date.format('dd, MMM D, YYYY');
            },
            WorkPeriod: function(wp) {
              scope.data.wp = wp;
              return scope.data.wp;
            },
            User: function(user) {
              scope.data.user = user;
              return scope.data.user;
            }
          };

          // All relations are imported from the parent note.
          // Copy the active relation into it's own object.
          var active_relation = lodash(scope.relations).filter({active: true}).first();
          var segments = [];

          if (!lodash.isNull(active_relation.obj)) {
            if (active_relation.obj === 'WorkPeriod') {
              segments.push({
                type: 'WorkPeriod'
              });
            } else if (active_relation.obj === 'Position') {
              segments.push({
                type: 'Position'
              });
            } else if (active_relation.obj === 'User') {
              segments.push({
                type: 'User'
              });
            }
          }

          if (active_relation.start_date && active_relation.end_date && active_relation.obj !== 'WorkPeriod') {
            segments.push({
              type: 'Dates'
            });
          }

          if (active_relation.start_date && !active_relation.end_date && active_relation.range_twix) {
            segments.push({
              type: 'OpenEndedDate'
            });
          }

          var fetcherPromises = [];

          lodash.each(segments, function(segment) {
            if (segment.type in fetchers) {
              fetcherPromises.push(fetchers[segment.type](active_relation.obj_id));
            } else {
              var def = $q.defer();
              def.resolve(active_relation);
              fetcherPromises.push(def.promise);
            }
          });

          $q.all(fetcherPromises)
            .then(function(results) {
              var content = [];
              lodash.each(segments, function(segment, idx) {
                var result = results[idx];
                if (segment.type in templates) {
                  if (segment.type in configurators) {
                    configurators[segment.type](result);
                  }
                  content.push($compile('<div class="sa-note-relation-segment ' + lodash.kebabCase(segment.type) + '">' + templates[segment.type] + '</div>')(scope));
                } else {
                  console.warn(segment.type + ": note relation type not recognized");
                }
              });

              setContent(content);
            }, function() {

            });
        }
      };
    }]);
